<div class="modal-body">
  <div class="content">
    <div class="content__main">
      <div class="top">
        <h4 translate>company.connectivity.details.equipment.edit-popup.title</h4>
        <button type="button" class="close" aria-label="Close" (click)="close()">
          <i class="icon-small-close" aria-hidden="true"></i>
        </button>
      </div>
      <ng-container *ngIf="!loading.equipmentInfoDetails">
        <gdp-add-edit-connectivity-equipment-form (onSubmit)="editReview($event)" [loading]="loading.submit"
          [equipment]="equipmentInfoDetails" [company]="company" [connectionId]="connectionId">
        </gdp-add-edit-connectivity-equipment-form>
      </ng-container>
      <div *ngIf="loading.equipmentInfoDetails" class="main">
        <ngx-skeleton-loader [theme]="{'height':'916px'}"></ngx-skeleton-loader>
      </div>
    </div>
  </div>
</div>